import { Col, Flex, notification, Row } from "antd";

import "./ProgramManagerDashboard.scss";
import { ProgramManagerDashboardSalesCard } from "./program-manager-dashboard-sales-card/ProgramManagerDashboardSalesCard";
import { ProgramManagerDashboardProjectCard } from "./program-manager-dashboard-project-card/ProgramManagerDashboardProjectCard";
import { SalesTargetTimePeriods } from "users/components";
import { useSalesInfo } from "sales/queries";
import { useProjectsInfo } from "projects/queries";
import { useBoundStore } from "store";
import { useEffect } from "react";
import variables from "../../../../_variables.scss";
import { NotesList } from "notes/components";

export const ProgramManagerDashboard = () => {
  const { currentOrganization } = useBoundStore();

  // Consolidated sales data hook — single request for all sales data
  const {
    data: salesInfo,
    error: salesError,
    isSuccess: salesInfoSuccess,
    refetch: refetchSalesInfo,
  } = useSalesInfo(currentOrganization?.id);

  const {
    data: projectsInfo,
    isSuccess: projectsInfoSuccess,
    error: projectsInfoError,
    refetch: refetchProjectsInfo,
  } = useProjectsInfo(currentOrganization?.id);

  const [api, notificationContextHolder] = notification.useNotification();

  const allDataReady = salesInfoSuccess && projectsInfoSuccess;

  const onSalesTargetTimePeriodChange = () => {
    refetchSalesInfo();
    refetchProjectsInfo();
  };

  useEffect(() => {
    if (salesError) {
      api.error({
        message: "Error loading sales info",
        description: (salesError as Error)?.message,
      });
    }

    if (projectsInfoError) {
      api.error({
        message: "Error loading projects info",
        description: (projectsInfoError as Error)?.message,
      });
    }
  }, [salesError, projectsInfoError, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Flex>
        <SalesTargetTimePeriods
          name='sales-target-time-periods'
          onChange={onSalesTargetTimePeriodChange}
        />
      </Flex>
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 32 }} justify='space-between'>
        <Col span={17}>
          <ProgramManagerDashboardSalesCard
            loading={!allDataReady}
            summaryCards={salesInfo?.salesCards}
            targetVsActualSales={salesInfo?.targetVsActualSales}
            salesByUtility={salesInfo?.salesByUtility}
            salesLeaderboard={salesInfo?.salesLeaderboard}
          />
        </Col>
        <Col span={7}>
          <NotesList title='My Project Notes' showCard />
        </Col>
      </Row>
      <ProgramManagerDashboardProjectCard
        loading={!projectsInfoSuccess}
        deficientProjects={projectsInfo?.deficientProjects}
        projectsByStage={projectsInfo?.projectsByStage}
        projectsTimeTrackingSummary={projectsInfo?.projectsTimeTrackingSummary}
      />
    </Flex>
  );
};
